import React from 'react';

export const Participants = ({ participants, audience }) => (
  <React.Fragment>
    <p>
      <strong>Organisateur(s) & participant(s) : </strong>
      {participants}
    </p>
    <p><strong>Public & audience : </strong>{audience}</p>
  </React.Fragment>
);

export default Participants;



// WEBPACK FOOTER //
// ./src/components/Summary/Controls/ControlParticipants.js